var AdaptiveImage = require( "../../../../../../react-native-web-image-loader/lib/modules/adaptiveImage.js" );

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "5223c8d9b0d08b82a5670fb5f71faf78.png",
    width: 50,
    height: 85
});